export const engagementAppGroupIdCanvasWorkflowIdAsyncAudiencePreview =
  "/engagement/:app_group_id/canvas/:workflow_id/async_audience_preview";
